import {
  FETCH_CREATED_VS_RESOLVED,
  FETCH_CREATED_VS_RESOLVED_SUCCESS,
  FETCH_CREATED_VS_RESOLVED_FAIL,
  FETCH_CREATED_WORK_ORDERS,
  FETCH_CREATED_WORK_ORDERS_SUCCESS,
  FETCH_CREATED_WORK_ORDERS_FAIL,
  FETCH_RESOLVED_WORK_ORDERS,
  FETCH_RESOLVED_WORK_ORDERS_SUCCESS,
  FETCH_RESOLVED_WORK_ORDERS_FAIL,
  SET_REPORT_DATE_RANGE,
  CLEAR_WORK_ORDER_LIST,
  FETCH_WORK_ORDERS_BY_TYPE,
  FETCH_WORK_ORDERS_BY_TYPE_SUCCESS,
  FETCH_WORK_ORDERS_BY_TYPE_FAIL,
  FETCH_WORK_ORDERS_BY_TYPE_LIST,
  FETCH_WORK_ORDERS_BY_TYPE_LIST_SUCCESS,
  FETCH_WORK_ORDERS_BY_TYPE_LIST_FAIL,
  FETCH_REPEATING_REPORT,
  FETCH_REPEATING_REPORT_SUCCESS,
  FETCH_REPEATING_REPORT_FAIL,
  FETCH_REPEATING_REPORT_LIST,
  FETCH_REPEATING_REPORT_LIST_SUCCESS,
  FETCH_REPEATING_REPORT_LIST_FAIL,
  FETCH_STATUS_REPORT,
  FETCH_STATUS_REPORT_SUCCESS,
  FETCH_STATUS_REPORT_FAIL,
  FETCH_STATUS_REPORT_LIST,
  FETCH_STATUS_REPORT_LIST_SUCCESS,
  FETCH_STATUS_REPORT_LIST_FAIL,
  FETCH_PRIORITY_REPORT,
  FETCH_PRIORITY_REPORT_SUCCESS,
  FETCH_PRIORITY_REPORT_FAIL,
  FETCH_PRIORITY_REPORT_LIST,
  FETCH_PRIORITY_REPORT_LIST_SUCCESS,
  FETCH_PRIORITY_REPORT_LIST_FAIL,
  FETCH_TIME_TO_COMPLETE,
  FETCH_TIME_TO_COMPLETE_SUCCESS,
  FETCH_TIME_TO_COMPLETE_FAIL,
  FETCH_COMPLETED_WORK_ORDERS,
  FETCH_COMPLETED_WORK_ORDERS_SUCCESS,
  FETCH_COMPLETED_WORK_ORDERS_FAIL,
  FETCH_MTTR_WORK_ORDERS,
  FETCH_MTTR_WORK_ORDERS_SUCCESS,
  FETCH_MTTR_WORK_ORDERS_FAIL,
  FETCH_ON_TIME_OVERDUE,
  FETCH_ON_TIME_OVERDUE_SUCCESS,
  FETCH_ON_TIME_OVERDUE_FAIL,
  FETCH_ON_TIME_OVERDUE_LIST,
  FETCH_ON_TIME_OVERDUE_LIST_SUCCESS,
  FETCH_ON_TIME_OVERDUE_LIST_FAIL,
  FETCH_COMPLETED_BY_USER,
  FETCH_COMPLETED_BY_USER_SUCCESS,
  FETCH_COMPLETED_BY_USER_FAIL,
  FETCH_COMPLETED_BY_USER_LIST,
  FETCH_COMPLETED_BY_USER_LIST_SUCCESS,
  FETCH_COMPLETED_BY_USER_LIST_FAIL,
  FETCH_STATUS_DURATION_REPORT,
  FETCH_STATUS_DURATION_REPORT_SUCCESS,
  FETCH_STATUS_DURATION_REPORT_FAIL,
  FETCH_ASSET_PERFORMANCE,
  FETCH_ASSET_PERFORMANCE_SUCCESS,
  FETCH_ASSET_PERFORMANCE_FAIL,
  FETCH_RECENT_ACTIVITY,
  FETCH_RECENT_ACTIVITY_SUCCESS,
  FETCH_RECENT_ACTIVITY_FAIL,
  FETCH_RECENT_ACTIVITY_MORE,
  FETCH_RECENT_ACTIVITY_MORE_SUCCESS,
  FETCH_RECENT_ACTIVITY_MORE_FAIL,
  SET_RECENT_ACTIVITY_FILTERS,
  CLEAR_RECENT_ACTIVITY,
  FETCH_CURRENT_STATUS,
  FETCH_CURRENT_STATUS_SUCCESS,
  FETCH_CURRENT_STATUS_FAIL,
  FETCH_MOST_PROBLEMATIC,
  FETCH_MOST_PROBLEMATIC_SUCCESS,
  FETCH_MOST_PROBLEMATIC_FAIL,
  FETCH_DOWNTIME_BREAKDOWN,
  FETCH_DOWNTIME_BREAKDOWN_SUCCESS,
  FETCH_DOWNTIME_BREAKDOWN_FAIL,
  FETCH_TOTAL_DOWNTIME,
  FETCH_TOTAL_DOWNTIME_SUCCESS,
  FETCH_TOTAL_DOWNTIME_FAIL,
  FETCH_DOWNTIME_COST,
  FETCH_DOWNTIME_COST_SUCCESS,
  FETCH_DOWNTIME_COST_FAIL,
  FETCH_WORK_ORDER_COST_REPORT,
  FETCH_WORK_ORDER_COST_REPORT_SUCCESS,
  FETCH_WORK_ORDER_COST_REPORT_FAIL,
  FETCH_MAINTENANCE_SPEND_BY_ASSET,
  FETCH_MAINTENANCE_SPEND_BY_ASSET_SUCCESS,
  FETCH_MAINTENANCE_SPEND_BY_ASSET_FAIL,
  EXPORT_CSV,
  EXPORT_CSV_SUCCESS,
  EXPORT_CSV_FAIL,
  CLEAR_EXPORT_STATE,
  EXPORT_GLOBAL_CSV,
} from './actionTypes';

// Created vs Resolved Report
export const fetchCreatedVsResolved = (startDate, endDate, organizationId, filters) => ({
  type: FETCH_CREATED_VS_RESOLVED,
  payload: { startDate, endDate, organizationId, filters },
});

export const fetchCreatedVsResolvedSuccess = (report) => ({
  type: FETCH_CREATED_VS_RESOLVED_SUCCESS,
  payload: report,
});

export const fetchCreatedVsResolvedFail = (error) => ({
  type: FETCH_CREATED_VS_RESOLVED_FAIL,
  payload: error,
});

// Created Work Orders List
export const fetchCreatedWorkOrders = (startDate, endDate, organizationId, periodStart, periodEnd, periodLabel) => ({
  type: FETCH_CREATED_WORK_ORDERS,
  payload: { startDate, endDate, organizationId, periodStart, periodEnd, periodLabel },
});

export const fetchCreatedWorkOrdersSuccess = (workOrderList) => ({
  type: FETCH_CREATED_WORK_ORDERS_SUCCESS,
  payload: workOrderList,
});

export const fetchCreatedWorkOrdersFail = (error) => ({
  type: FETCH_CREATED_WORK_ORDERS_FAIL,
  payload: error,
});

// Resolved Work Orders List
export const fetchResolvedWorkOrders = (startDate, endDate, organizationId, periodStart, periodEnd, periodLabel) => ({
  type: FETCH_RESOLVED_WORK_ORDERS,
  payload: { startDate, endDate, organizationId, periodStart, periodEnd, periodLabel },
});

export const fetchResolvedWorkOrdersSuccess = (workOrderList) => ({
  type: FETCH_RESOLVED_WORK_ORDERS_SUCCESS,
  payload: workOrderList,
});

export const fetchResolvedWorkOrdersFail = (error) => ({
  type: FETCH_RESOLVED_WORK_ORDERS_FAIL,
  payload: error,
});

// Date Range
export const setReportDateRange = (startDate, endDate) => ({
  type: SET_REPORT_DATE_RANGE,
  payload: { startDate, endDate },
});

// Clear Work Order List
export const clearWorkOrderList = () => ({
  type: CLEAR_WORK_ORDER_LIST,
});

// Work Orders by Type Report
export const fetchWorkOrdersByType = (startDate, endDate, organizationId, filters) => ({
  type: FETCH_WORK_ORDERS_BY_TYPE,
  payload: { startDate, endDate, organizationId, filters },
});

export const fetchWorkOrdersByTypeSuccess = (report) => ({
  type: FETCH_WORK_ORDERS_BY_TYPE_SUCCESS,
  payload: report,
});

export const fetchWorkOrdersByTypeFail = (error) => ({
  type: FETCH_WORK_ORDERS_BY_TYPE_FAIL,
  payload: error,
});

// Work Orders by Type List
export const fetchWorkOrdersByTypeList = (startDate, endDate, organizationId, workType, periodStart, periodEnd, periodLabel) => ({
  type: FETCH_WORK_ORDERS_BY_TYPE_LIST,
  payload: { startDate, endDate, organizationId, workType, periodStart, periodEnd, periodLabel },
});

export const fetchWorkOrdersByTypeListSuccess = (workOrderList) => ({
  type: FETCH_WORK_ORDERS_BY_TYPE_LIST_SUCCESS,
  payload: workOrderList,
});

export const fetchWorkOrdersByTypeListFail = (error) => ({
  type: FETCH_WORK_ORDERS_BY_TYPE_LIST_FAIL,
  payload: error,
});

// Repeating Report
export const fetchRepeatingReport = (startDate, endDate, organizationId, filters) => ({
  type: FETCH_REPEATING_REPORT,
  payload: { startDate, endDate, organizationId, filters },
});

export const fetchRepeatingReportSuccess = (report) => ({
  type: FETCH_REPEATING_REPORT_SUCCESS,
  payload: report,
});

export const fetchRepeatingReportFail = (error) => ({
  type: FETCH_REPEATING_REPORT_FAIL,
  payload: error,
});

// Repeating Report List
export const fetchRepeatingReportList = (startDate, endDate, organizationId, isRepeating, periodStart, periodEnd, periodLabel) => ({
  type: FETCH_REPEATING_REPORT_LIST,
  payload: { startDate, endDate, organizationId, isRepeating, periodStart, periodEnd, periodLabel },
});

export const fetchRepeatingReportListSuccess = (workOrderList) => ({
  type: FETCH_REPEATING_REPORT_LIST_SUCCESS,
  payload: workOrderList,
});

export const fetchRepeatingReportListFail = (error) => ({
  type: FETCH_REPEATING_REPORT_LIST_FAIL,
  payload: error,
});

// Status Report
export const fetchStatusReport = (startDate, endDate, organizationId, filters) => ({
  type: FETCH_STATUS_REPORT,
  payload: { startDate, endDate, organizationId, filters },
});

export const fetchStatusReportSuccess = (report) => ({
  type: FETCH_STATUS_REPORT_SUCCESS,
  payload: report,
});

export const fetchStatusReportFail = (error) => ({
  type: FETCH_STATUS_REPORT_FAIL,
  payload: error,
});

// Status Report List
export const fetchStatusReportList = (startDate, endDate, organizationId, status) => ({
  type: FETCH_STATUS_REPORT_LIST,
  payload: { startDate, endDate, organizationId, status },
});

export const fetchStatusReportListSuccess = (workOrderList) => ({
  type: FETCH_STATUS_REPORT_LIST_SUCCESS,
  payload: workOrderList,
});

export const fetchStatusReportListFail = (error) => ({
  type: FETCH_STATUS_REPORT_LIST_FAIL,
  payload: error,
});

// Priority Report
export const fetchPriorityReport = (startDate, endDate, organizationId, filters) => ({
  type: FETCH_PRIORITY_REPORT,
  payload: { startDate, endDate, organizationId, filters },
});

export const fetchPriorityReportSuccess = (report) => ({
  type: FETCH_PRIORITY_REPORT_SUCCESS,
  payload: report,
});

export const fetchPriorityReportFail = (error) => ({
  type: FETCH_PRIORITY_REPORT_FAIL,
  payload: error,
});

// Priority Report List
export const fetchPriorityReportList = (startDate, endDate, organizationId, priority) => ({
  type: FETCH_PRIORITY_REPORT_LIST,
  payload: { startDate, endDate, organizationId, priority },
});

export const fetchPriorityReportListSuccess = (workOrderList) => ({
  type: FETCH_PRIORITY_REPORT_LIST_SUCCESS,
  payload: workOrderList,
});

export const fetchPriorityReportListFail = (error) => ({
  type: FETCH_PRIORITY_REPORT_LIST_FAIL,
  payload: error,
});

// Time to Complete Report
export const fetchTimeToComplete = (startDate, endDate, organizationId, filters) => ({
  type: FETCH_TIME_TO_COMPLETE,
  payload: { startDate, endDate, organizationId, filters },
});

export const fetchTimeToCompleteSuccess = (report) => ({
  type: FETCH_TIME_TO_COMPLETE_SUCCESS,
  payload: report,
});

export const fetchTimeToCompleteFail = (error) => ({
  type: FETCH_TIME_TO_COMPLETE_FAIL,
  payload: error,
});

// Completed Work Orders List (for Total Hours / AVG Hours drill-down)
export const fetchCompletedWorkOrders = (startDate, endDate, organizationId, periodStart, periodEnd, periodLabel) => ({
  type: FETCH_COMPLETED_WORK_ORDERS,
  payload: { startDate, endDate, organizationId, periodStart, periodEnd, periodLabel },
});

export const fetchCompletedWorkOrdersSuccess = (workOrderList) => ({
  type: FETCH_COMPLETED_WORK_ORDERS_SUCCESS,
  payload: workOrderList,
});

export const fetchCompletedWorkOrdersFail = (error) => ({
  type: FETCH_COMPLETED_WORK_ORDERS_FAIL,
  payload: error,
});

// MTTR Work Orders List (for MTTR AVG Hours drill-down)
export const fetchMttrWorkOrders = (startDate, endDate, organizationId, periodStart, periodEnd, periodLabel) => ({
  type: FETCH_MTTR_WORK_ORDERS,
  payload: { startDate, endDate, organizationId, periodStart, periodEnd, periodLabel },
});

export const fetchMttrWorkOrdersSuccess = (workOrderList) => ({
  type: FETCH_MTTR_WORK_ORDERS_SUCCESS,
  payload: workOrderList,
});

export const fetchMttrWorkOrdersFail = (error) => ({
  type: FETCH_MTTR_WORK_ORDERS_FAIL,
  payload: error,
});

// On Time vs Overdue Report
export const fetchOnTimeOverdue = (startDate, endDate, organizationId, filters) => ({
  type: FETCH_ON_TIME_OVERDUE,
  payload: { startDate, endDate, organizationId, filters },
});

export const fetchOnTimeOverdueSuccess = (report) => ({
  type: FETCH_ON_TIME_OVERDUE_SUCCESS,
  payload: report,
});

export const fetchOnTimeOverdueFail = (error) => ({
  type: FETCH_ON_TIME_OVERDUE_FAIL,
  payload: error,
});

// On Time vs Overdue List
export const fetchOnTimeOverdueList = (startDate, endDate, organizationId, overdueStatus, isRepeating) => ({
  type: FETCH_ON_TIME_OVERDUE_LIST,
  payload: { startDate, endDate, organizationId, overdueStatus, isRepeating },
});

export const fetchOnTimeOverdueListSuccess = (workOrderList) => ({
  type: FETCH_ON_TIME_OVERDUE_LIST_SUCCESS,
  payload: workOrderList,
});

export const fetchOnTimeOverdueListFail = (error) => ({
  type: FETCH_ON_TIME_OVERDUE_LIST_FAIL,
  payload: error,
});

// Completed by User Report
export const fetchCompletedByUser = (startDate, endDate, organizationId, filters) => ({
  type: FETCH_COMPLETED_BY_USER,
  payload: { startDate, endDate, organizationId, filters },
});

export const fetchCompletedByUserSuccess = (report) => ({
  type: FETCH_COMPLETED_BY_USER_SUCCESS,
  payload: report,
});

export const fetchCompletedByUserFail = (error) => ({
  type: FETCH_COMPLETED_BY_USER_FAIL,
  payload: error,
});

// Completed by User List
export const fetchCompletedByUserList = (organizationId, userId, weekStart, weekEnd) => ({
  type: FETCH_COMPLETED_BY_USER_LIST,
  payload: { organizationId, userId, weekStart, weekEnd },
});

export const fetchCompletedByUserListSuccess = (workOrderList) => ({
  type: FETCH_COMPLETED_BY_USER_LIST_SUCCESS,
  payload: workOrderList,
});

export const fetchCompletedByUserListFail = (error) => ({
  type: FETCH_COMPLETED_BY_USER_LIST_FAIL,
  payload: error,
});

// Status Duration Report
export const fetchStatusDurationReport = (startDate, endDate, organizationId, filters) => ({
  type: FETCH_STATUS_DURATION_REPORT,
  payload: { startDate, endDate, organizationId, filters },
});

export const fetchStatusDurationReportSuccess = (report) => ({
  type: FETCH_STATUS_DURATION_REPORT_SUCCESS,
  payload: report,
});

export const fetchStatusDurationReportFail = (error) => ({
  type: FETCH_STATUS_DURATION_REPORT_FAIL,
  payload: error,
});

// Asset Performance Report
export const fetchAssetPerformance = (startDate, endDate, organizationId) => ({
  type: FETCH_ASSET_PERFORMANCE,
  payload: { startDate, endDate, organizationId },
});

export const fetchAssetPerformanceSuccess = (report) => ({
  type: FETCH_ASSET_PERFORMANCE_SUCCESS,
  payload: report,
});

export const fetchAssetPerformanceFail = (error) => ({
  type: FETCH_ASSET_PERFORMANCE_FAIL,
  payload: error,
});

// Recent Activity Report
export const fetchRecentActivity = (params) => ({
  type: FETCH_RECENT_ACTIVITY,
  payload: params,
});

export const fetchRecentActivitySuccess = (data) => ({
  type: FETCH_RECENT_ACTIVITY_SUCCESS,
  payload: data,
});

export const fetchRecentActivityFail = (error) => ({
  type: FETCH_RECENT_ACTIVITY_FAIL,
  payload: error,
});

// Recent Activity Load More
export const fetchRecentActivityMore = (params) => ({
  type: FETCH_RECENT_ACTIVITY_MORE,
  payload: params,
});

export const fetchRecentActivityMoreSuccess = (data) => ({
  type: FETCH_RECENT_ACTIVITY_MORE_SUCCESS,
  payload: data,
});

export const fetchRecentActivityMoreFail = (error) => ({
  type: FETCH_RECENT_ACTIVITY_MORE_FAIL,
  payload: error,
});

// Recent Activity Filters
export const setRecentActivityFilters = (filters) => ({
  type: SET_RECENT_ACTIVITY_FILTERS,
  payload: filters,
});

export const clearRecentActivity = () => ({
  type: CLEAR_RECENT_ACTIVITY,
});

// CSV Export
export const exportCsv = (exportType, params) => ({
  type: EXPORT_CSV,
  payload: { exportType, ...params },
});

export const exportCsvSuccess = () => ({
  type: EXPORT_CSV_SUCCESS,
});

export const exportCsvFail = (error) => ({
  type: EXPORT_CSV_FAIL,
  payload: error,
});

export const clearExportState = () => ({
  type: CLEAR_EXPORT_STATE,
});

// Global CSV Export — fans out across every org the caller can globally view.
// `params` may contain { startDate, endDate } when the export type accepts a
// date range. `subOrgIds` is intentionally omitted: the backend resolves the
// caller's full aggregate-view org set when none is supplied.
export const exportGlobalCsv = (exportType, params = {}) => ({
  type: EXPORT_GLOBAL_CSV,
  payload: { exportType, ...params },
});

// Asset Health: Most Problematic Assets Report
export const fetchMostProblematic = (organizationId, startDate, endDate, criticality, locationId, vendorId, assetId, assetTypeId, contractNumber) => ({
  type: FETCH_MOST_PROBLEMATIC,
  payload: { organizationId, startDate, endDate, criticality, locationId, vendorId, assetId, assetTypeId, contractNumber },
});

export const fetchMostProblematicSuccess = (report) => ({
  type: FETCH_MOST_PROBLEMATIC_SUCCESS,
  payload: report,
});

export const fetchMostProblematicFail = (error) => ({
  type: FETCH_MOST_PROBLEMATIC_FAIL,
  payload: error,
});

// Asset Health: Current Status Report
export const fetchCurrentStatus = (organizationId, criticality, locationId, vendorId, assetId, assetTypeId, contractNumber) => ({
  type: FETCH_CURRENT_STATUS,
  payload: { organizationId, criticality, locationId, vendorId, assetId, assetTypeId, contractNumber },
});

export const fetchCurrentStatusSuccess = (report) => ({
  type: FETCH_CURRENT_STATUS_SUCCESS,
  payload: report,
});

export const fetchCurrentStatusFail = (error) => ({
  type: FETCH_CURRENT_STATUS_FAIL,
  payload: error,
});

// Asset Health: Downtime Breakdown Report
export const fetchDowntimeBreakdown = (organizationId, startDate, endDate, criticality, locationId, vendorId, assetId, assetTypeId, contractNumber) => ({
  type: FETCH_DOWNTIME_BREAKDOWN,
  payload: { organizationId, startDate, endDate, criticality, locationId, vendorId, assetId, assetTypeId, contractNumber },
});

export const fetchDowntimeBreakdownSuccess = (report) => ({
  type: FETCH_DOWNTIME_BREAKDOWN_SUCCESS,
  payload: report,
});

export const fetchDowntimeBreakdownFail = (error) => ({
  type: FETCH_DOWNTIME_BREAKDOWN_FAIL,
  payload: error,
});

// Asset Health: Total Downtime Report
export const fetchTotalDowntime = (organizationId, startDate, endDate, criticality, locationId, vendorId, assetId, assetTypeId, contractNumber) => ({
  type: FETCH_TOTAL_DOWNTIME,
  payload: { organizationId, startDate, endDate, criticality, locationId, vendorId, assetId, assetTypeId, contractNumber },
});

export const fetchTotalDowntimeSuccess = (report) => ({
  type: FETCH_TOTAL_DOWNTIME_SUCCESS,
  payload: report,
});

export const fetchTotalDowntimeFail = (error) => ({
  type: FETCH_TOTAL_DOWNTIME_FAIL,
  payload: error,
});

// Asset Health: Downtime Cost Report
export const fetchDowntimeCost = (organizationId, startDate, endDate, criticality, locationId, vendorId, assetId, assetTypeId, contractNumber) => ({
  type: FETCH_DOWNTIME_COST,
  payload: { organizationId, startDate, endDate, criticality, locationId, vendorId, assetId, assetTypeId, contractNumber },
});

export const fetchDowntimeCostSuccess = (report) => ({
  type: FETCH_DOWNTIME_COST_SUCCESS,
  payload: report,
});

export const fetchDowntimeCostFail = (error) => ({
  type: FETCH_DOWNTIME_COST_FAIL,
  payload: error,
});

// Work Order Cost Report (labor / parts / contractor)
export const fetchWorkOrderCostReport = (startDate, endDate, organizationId, filters) => ({
  type: FETCH_WORK_ORDER_COST_REPORT,
  payload: { startDate, endDate, organizationId, filters },
});

export const fetchWorkOrderCostReportSuccess = (report) => ({
  type: FETCH_WORK_ORDER_COST_REPORT_SUCCESS,
  payload: report,
});

export const fetchWorkOrderCostReportFail = (error) => ({
  type: FETCH_WORK_ORDER_COST_REPORT_FAIL,
  payload: error,
});

// Asset Health: Maintenance Spend by Asset
export const fetchMaintenanceSpendByAsset = (
  organizationId, startDate, endDate,
  criticality, locationId, vendorId, assetId, assetTypeId, contractNumber,
  limit, offset, sortBy,
) => ({
  type: FETCH_MAINTENANCE_SPEND_BY_ASSET,
  payload: {
    organizationId, startDate, endDate,
    criticality, locationId, vendorId, assetId, assetTypeId, contractNumber,
    limit, offset, sortBy,
  },
});

export const fetchMaintenanceSpendByAssetSuccess = (report) => ({
  type: FETCH_MAINTENANCE_SPEND_BY_ASSET_SUCCESS,
  payload: report,
});

export const fetchMaintenanceSpendByAssetFail = (error) => ({
  type: FETCH_MAINTENANCE_SPEND_BY_ASSET_FAIL,
  payload: error,
});
